import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Stack, Typography, FormControlLabel, Checkbox, Select, MenuItem } from '@mui/material'; // Added MenuItem

import { useAppContext } from '../context/AppContext';
import { useToast } from '../context/ToastContext';
import { getRoles } from '@testing-library/dom';
const UsersForm = ({ onSubmit, initialData }) => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { showCorrect, showError } = useToast();
  const [form, setForm] = useState(initialData || {
    client_first_name: '',
    client_last_name: '',
    partner_first_name: '',
    partner_last_name: '',
    username: '',
    email: '',
    organization: '',
    password: '',
    passwordCheck: '',
    manager: false,
    role: ""
  });

  const { getUser, updateUser_PasswordRoleOrganization } = useAppContext();

    
  useEffect(() => {
    const effectAsync = async () => {
      if (initialData) {
        setForm(initialData);
      } else {
        const user = await getUser(id);
        console.log('user', user);
        if (user) {
          setForm({
            client_first_name: user.client_first_name,
            client_last_name: user.client_last_name,
            partner_first_name: user.partner_first_name,
            partner_last_name: user.partner_last_name,
            username: user.username,
            email: user.email,
            organization: user.organization,
            password: '',
            passwordCheck: '',
            manager: false,
            role: ""
          });
        } else {
          // Optionally handle the error, e.g. show a toast or redirect
          showError('User not found');
        }
      }
    }
    effectAsync();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleChangeSelect = (e) => {
    console.log("handleChangeSelect", e.target.name, e.target.value)
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.checked });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("handleSubmit", form);
    // console.log("form.password !== \"\"", form.password !== "")
    if (form.password === "") {
      alert('Password cannot be empty');
      return;
    }

    if (form.password !== form.passwordCheck) {
      alert('Passwords do not match');
      return;
    }

    try{
      await updateUser_PasswordRoleOrganization(id, form.password, form.role, form.manager);
      showCorrect('User updated successfully');
      navigate('/users');
    } catch (err) {
      console.error(err);
      showError('Error updating user');
    }
    
  };

  return (
    <form onSubmit={handleSubmit} >
      <Typography variant="h6">User</Typography>
      <Stack spacing={2} direction="column" sx={{ my: 2 }}>
        <TextField
          label="Client First Name"
          name="client_first_name"
          value={form.client_first_name}
          disabled={true}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Client Last Name"
          name="client_last_name"
          value={form.client_last_name}
          disabled={true}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Partner First Name"
          name="partner_first_name"
          value={form.partner_first_name}
          disabled={true}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Partner Last Name"
          name="partner_last_name"
          value={form.partner_last_name}
          disabled={true}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Username"
          name="username"
          value={form.username}
          disabled={true}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Password"
          name="password"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Password Repeat"
          placeholder="Password Repeat"
          name="passwordCheck"
          type="password"
          value={form.passwordCheck}
          onChange={handleChange}
          fullWidth
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={form.manager}
              onChange={handleCheckboxChange}
              name="manager"
            />
          }
          label="Org Manager"
        />
        <Button variant="contained" type="submit" fullWidth>
          Update Password
        </Button>
      </Stack>
    </form>
  );
};

export default UsersForm;
